import { format } from "date-fns"
import { CountryOptions } from "../../data/CountryOptions"
import { formatPhoneUSA } from "../formatPhoneUSA"
import { sanitizeZipcode } from "../sanitizeZipcode"
import moment from "moment"
import store from '../../../setup/redux/Store';

export const normalizeParamsShipment = (data, mode, selectedUn) => {
    let locations = ['shipper', 'consignee'].map((location) => {
        return ({[location]: {
          "id": data[location]?.id || null,
          "name": data[location]?.name,
          "referenceNumber": data[location].referenceNumber,
          "address1": data[location]?.address,
          "address2": data[location]?.address1,
          "city": data[location]?.city,
          "state": data[location]?.state?.trim() || '',
          "zipCode": sanitizeZipcode(data[location]?.zipcode),
          "country": data[location]?.country?.length === 3 ? CountryOptions.filter(con => con.CodePrimus === data[location]?.country)[0]?.Code || data[location]?.country : data[location]?.country,
          "phone": (data[location]?.country?.includes('US') || data[location]?.country?.includes('CA')) ? formatPhoneUSA(data[location]?.phone, 'USA') || '' : data[location]?.phone,
          "fax": "",
          "email": data[location]?.emails?.length ? data[location]?.emails?.map(email => email?.includes('notanemail@gmail.com') ? email?.replace('notanemail@gmail.com', '') : email)?.join(', ') : "",
          "contact": data[location]?.contact,
          "contactPhone": (data[location]?.country?.includes('US') || data[location]?.country?.includes('CA')) ? formatPhoneUSA(data[location]?.contactPhone, 'USA') || '' : data[location]?.contactPhone,
          "UNLOCode": data[location]?.UNLOCode?.code || '',
          "UNLOCodeCity": data[location]?.UNLOCode?.name || '',
          "IATA": data[location].IATACode || '',
          "showName": data[location]?.tradeShow?.showName,
          "venueName": data[location]?.tradeShow?.venueName,
          "booth": data[location]?.tradeShow?.booth
        }})
    })
    
    let overrides = data.freightInfo.map(f => f.overrideClass)

    let user = store?.getState()?.auth?.user

    // const numbersForInsuranceAmout = data?.insuranceAmount ? data?.insuranceAmount : ''
    // const highestInsuranceAmount = Math?.max(...numbersForInsuranceAmout)
    // const highestInsuranceAmount = numbersForInsuranceAmout
    // const indexOfHighest = numbersForInsuranceAmout?.indexOf(highestInsuranceAmount)

    const formatTwoDecimals = (value) => {
      return value ? parseFloat(value).toFixed(2).replace(/\.00$/, '') || 0 : null
    }

    let params = {
      //overrideClass: overrides?.length === 1 && overrides[0] === undefined ? undefined : overrides?.includes(false) ? true : overrides?.includes(true) ? false : undefined,
      modeId: mode?.id,
      shipper: locations[0].shipper,
      consignee: locations[1].consignee,
      thirdPartyReferenceNumber: data?.billTo?.referenceNumber,
      thirdPartyEmail: data?.billTo?.emails?.length ? data?.billTo?.emails?.map(email => email?.includes('notanemail@gmail.com') ? email?.replace('notanemail@gmail.com', '') : email)?.join(', ') : "",
      commodityInsurance: data.commodityInsurance ? data.commodityInsurance : undefined,
      coverTypeInsurance: data.coverTypeInsurance ? data.coverTypeInsurance : undefined,
      insuranceAmount:  data.insuranceAmount ? data.insuranceAmount : '',
      insuranceFreight: data.insuranceFreight ? data.insuranceFreight : false,
      insuranceAddOn: data.insuranceAddOn ? data.insuranceAddOn : false,
      duplicatedBooking: data.isBookingDuplicated ? data.isBookingDuplicated : false,
      bookingIdCopiedFrom: data.bookingIdCopiedFrom ? data.bookingIdCopiedFrom : '',
      reversedBooking: data.reversedBooking ? data.reversedBooking : '',
      PRONmbr: data?.PRONmbr,
      BOLNmbr: !data?.BOLId ? (data?.BOLNumber || null) : null,
      quoteNumber: !data?.collectQuoteNumber ? (data?.quoteNumber || null) : null,
      "lineItems": data?.freightInfo[0]?.qty ? data?.freightInfo?.map((freight, index) => {
        let selectedUnIndex = selectedUn?.filter(s => s.index === index)[0]
        return mode?.shipmentCategory === 'Drayage' ? {
          qty: parseFloat(freight.qty),
          weight: parseFloat(freight.weight),
          weightType: "each",
          class: 0,
          insuranceAmount: '',
          pickupDate: new Date().toISOString().slice(0, 10),
          length: 1,
          width: 1,
          height: 1,
          volume: freight.volume,
          dimTypeDrayage: freight.container,
          freightsnapId: freight.freightsnapId || null,
          hazmat: freight.hazmat,
          stack: false,
          overweight: freight.freightInfoAccessorials?.includes('Overweight'),
          reefer: freight.freightInfoAccessorials?.includes('Reefer'),
          residentialDelivery: freight.freightInfoAccessorials?.includes('Residential Delivery'),
          householdGoods: freight.freightInfoAccessorials?.includes('Household Goods'),
          liquor: freight.freightInfoAccessorials?.includes('Liquor'),
          storageYard: freight.freightInfoAccessorials?.includes('Storage Yard'),
          CYDepot: freight.freightInfoAccessorials?.includes('CY/Depot'),
          UN: freight?.UN,
          UNDescription: selectedUnIndex?.description,
          UNHAZClass:  selectedUnIndex?.HAZClass,
          UNPKGGroup: selectedUnIndex?.PKGGroup,
          UNLabels: selectedUnIndex?.labels,
        }
        : {
          "qty": freight.qty,
          "weight": formatTwoDecimals(freight.weight),
          "weightType": freight.each?.toLowerCase(),
          "length": formatTwoDecimals(freight.L),
          "width": formatTwoDecimals(freight.W),
          "height": formatTwoDecimals(freight.H),
          "dimType": freight.dimType?.value,
          "STC": freight.STC,
          "class": data.carrierInformation?.classesReClassed?.length ? parseFloat(data.carrierInformation?.classesReClassed[index]) : (parseFloat(freight.class) || 0),
          "hazmat": freight.hazmat,
          "nmfc": freight.nmfc || null,
          "commodity": freight.commodity,
          "freightsnapId": freight.freightsnapId || null,
          "UN": freight?.UN,
          volume: freight.volume,
          UNDescription: selectedUnIndex?.description,
          UNHAZClass:  selectedUnIndex?.HAZClass,
          UNPKGGroup: selectedUnIndex?.PKGGroup,
          UNLabels: selectedUnIndex?.labels,
          "stack": (freight.stack === 'No' || !freight.stack) ? false : true,
          "stackAmount": (freight.stack === 'No' || !freight.stack) ? null : parseInt(freight.stack) ? parseInt(freight.stack) : parseInt(freight.stackAmount),
          "stopNumber": freight.stopNumber,
          overrideClass: freight.overrideClass === undefined ? undefined : (data.carrierInformation?.classesReClassed?.length && parseFloat(data.carrierInformation?.classesReClassed[index])) ? true : !freight.overrideClass
        }
      }) : [],
      "UOM": data?.freightInfoUOM?.value,
      "pickupInformation": {
        "date": data?.pickupDate?.date ? format(data?.pickupDate?.date || null, 'yyyy-MM-dd') : "",
        "type": data?.pickupDate?.type === 'PickupOn' ? "PO" : "PB",
        "timeFrom": data?.pickupDate?.from && (data?.pickupDate?.from.length > 5 ? moment(data?.pickupDate?.from, 'HH:mm:ss').format('HH:mm') : data?.pickupDate?.from.includes(':') ? data?.pickupDate?.from || "" : data?.pickupDate?.from.slice(0, 2) + ":" + data?.pickupDate?.from.slice(2)),
        "timeTo": data?.pickupDate?.to && (data?.pickupDate?.to.length > 5 ? moment(data?.pickupDate?.to, 'HH:mm:ss').format('HH:mm') : data?.pickupDate?.to.includes(':') ? data?.pickupDate?.to || "" : data?.pickupDate?.to.slice(0, 2) + ":" + data?.pickupDate?.to.slice(2)),
        "appointmentNeeded": data?.pickupDate?.appointmentNeeded || false,
        "appointmentDate": data?.pickupDate?.appointmentDate ? format(data?.pickupDate?.appointmentDate, 'yyyy-MM-dd') : "",
        "appointmentTime": data?.pickupDate?.appointmentTime && data.pickupDate.appointmentTime !== '0000' && data.pickupDate.appointmentTime !== '00:00' && data.pickupDate.appointmentTime !== '00:00:00' ? (data.pickupDate.appointmentTime.length > 5 ? moment(data.pickupDate.appointmentTime, 'HH:mm:ss').format('HH:mm') : data.pickupDate.appointmentTime.includes(':') ? data.pickupDate.appointmentTime : data.pickupDate.appointmentTime.slice(0, 2) + ':' + data.pickupDate.appointmentTime.slice(2)) : "",
        "appointmentNumber": data?.pickupDate?.appointmentNumber || "",
        "appointmentContact": data?.pickupDate?.appointmentContact || "",
        "appointmentNotes": data?.pickupDate?.appointmentNotes || "",
      },
      "deliveryInformation": data?.deliveryDate?.date ? {
        "date": format(data?.deliveryDate?.date, 'yyyy-MM-dd'),
        "type": data?.deliveryDate?.type === 'DeliveryOn' ? "DO" : "DB",
        "timeFrom": data?.deliveryDate?.from && (data?.deliveryDate?.from.length > 5 ? moment(data?.deliveryDate?.from, 'HH:mm:ss').format('HH:mm') : data?.deliveryDate?.from.includes(':') ? data?.deliveryDate?.from || "" : data?.deliveryDate?.from.slice(0, 2) + ":" + data?.deliveryDate?.from.slice(2)),
        "timeTo": data?.deliveryDate?.to && (data?.deliveryDate?.to.length > 5 ? moment(data?.deliveryDate?.to, 'HH:mm:ss').format('HH:mm') : data?.deliveryDate?.to.includes(':') ? data?.deliveryDate?.to || "" : data?.deliveryDate?.to.slice(0, 2) + ":" + data?.deliveryDate?.to.slice(2)),
        "appointmentNeeded": data?.deliveryDate?.appointmentNeeded || false,
        "appointmentDate": data?.deliveryDate?.appointmentDate ? format(data?.deliveryDate?.appointmentDate, 'yyyy-MM-dd') : "",
        "appointmentTime": data?.deliveryDate?.appointmentTime && data.deliveryDate.appointmentTime !== '0000' && data.deliveryDate.appointmentTime !== '00:00' && data.deliveryDate.appointmentTime !== '00:00:00' ? (data.deliveryDate.appointmentTime.length > 5 ? moment(data.deliveryDate.appointmentTime, 'HH:mm:ss').format('HH:mm') : data.deliveryDate.appointmentTime.includes(':') ? data.deliveryDate.appointmentTime : data.deliveryDate.appointmentTime.slice(0, 2) + ':' + data.deliveryDate.appointmentTime.slice(2)) : "",
        "appointmentNumber": data?.deliveryDate?.appointmentNumber || "",
        "appointmentContact": data?.deliveryDate?.appointmentContact || "",
        "appointmentNotes": data?.deliveryDate?.appointmentNotes || "",
      } : null,
      "BOLInstructions": data?.specialInstructions,
      "shipmentNotes": data?.shipmentNotes,
      "additionalInformation": {
        "shipmentReference1": data?.otherInfo?.refNumber1,
        "shipmentReference2": data?.otherInfo?.refNumber2,
        "BKGRef": data?.otherInfo?.BKGRefNumber,
        "incoTerm": data?.otherInfo?.incoTerm,
        "ITNNumber": data?.otherInfo?.exportFiling === 'ITN' ? (data?.otherInfo?.itnNumber || '') : '',
        "dutyAndTaxPayableBy": data?.otherInfo?.dutyAndTaxPayableBy || '',
        "exportFiling": data?.otherInfo?.exportFiling || '',
        "FTRExemption": data?.otherInfo?.exportFiling === 'FTR' ? (data?.otherInfo?.ftrExemptionCode || '') : '',
        "receiverAccountNumber": data?.otherInfo?.dutyAndTaxPayableBy === 'Receiver' ? (data?.otherInfo?.receiverAccountNumber || '') : '',
        "DHLNotificationEmail": data?.otherInfo?.dhlNotificationEmail || '',
        "paperlessTrade": data?.otherInfo?.paperlessTrade || false,
        "dutiesPaid": data?.otherInfo?.dutiesPaid || false,
      },
      "brokerInformation": {
        "name": data?.otherInfo.broker.name,
        "contact": data?.otherInfo.broker.contact,
        "phone": formatPhoneUSA(data.otherInfo.broker.phone, 'USA'),
        "notes": data?.otherInfo.broker.instructions,
        "customsValue": data?.otherInfo?.BKGValue
      },
      "accessorialsList": [...data?.accessorials.origin.map((acc) => acc.code), ...data?.accessorials.destination.map((acc) => acc.code), ...data?.accessorials.other.map((acc) => acc.code)],
      "emergencyContact": data.freightInfo?.some(f => f.hazmat) ? data.emergencyContact : null,
      "emergencyPhone": data.freightInfo?.some(f => f.hazmat) ? data.emergencyPhone : null,
      "stopsInformation": {
        "serviceType": data?.stops?.serviceType || 'EXCLUSIVE',
        "equipments": data?.stops?.equipment || [],
        "equipmentLength": data?.stops?.length || 0,
        "stops": data?.stops.stops.length || 0,
      },
    }
  
    if(!user?.allowPROModify){
      delete params["PRONmbr"];
    }
    if(data?.collect) {
      params["billToCollect"] =  data?.collect || ''
      params["collectQuoteNumber"] = data?.collectQuoteNumber || null
      params["collectVendorId"] = data?.collectVendorId || null
      params["collectQuoteAmount"] = data?.collectQuoteAmount ? parseFloat(data?.collectQuoteAmount) : null
      params["collectVendorName"] = data?.collectVendorName || null
    }
    else {
      params["billToCollect"] =  ''
    }
    if(data.billToData?.name) {
      params["billToData"] = data.billToData
    }

    return params
}